import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";
import { SignatureStatusType, SignatureRequestStatusType } from "../Enums/SignatureStatusType";

export class ReservationSignatureStatusModel extends ModelBase<ReservationSignatureStatusModel, ReservationSignatureStatusDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationId: string = "";

    @observable
    public requestStatus: SignatureRequestStatusType = SignatureRequestStatusType.Draft;

    @observable
    public publishedDate: string = "";

    @observable
    public expiryDate: string = "";

    @observable
    public completedDate: string = "";

    @observable
    public purchaserOneStatus: SignatureStatusType = SignatureStatusType.Pending;

    @observable
    public purchaserOneToken: string = "";

    @observable
    public purchaserOneEmailSentDate: string = "";

    @observable
    public purchaserOneSignedDate: string = "";

    @observable
    public purchaserTwoStatus: SignatureStatusType = SignatureStatusType.Pending;

    @observable
    public purchaserTwoToken: string = "";

    @observable
    public purchaserTwoEmailSentDate: string = "";

    @observable
    public purchaserTwoSignedDate: string = "";

    @observable
    public salesAgentStatus: SignatureStatusType = SignatureStatusType.Pending;

    @observable
    public salesAgentSignedDate: string = "";

    @observable
    public version: number = 1;

    @observable
    public isActive: boolean = true;

    @observable
    public createdDate: string = "";

    @observable
    public createdByIdentityUserId: string = "";

    @observable
    public lastModifiedDate: string = "";

    @observable
    public lastModifiedByIdentityUserId: string = "";
    //#endregion Properties

    @action
    public fromDto = (dto: ReservationSignatureStatusDTO) => {
        this.id = dto.id;
        this.reservationId = dto.reservationId;
        this.requestStatus = dto.requestStatus;
        this.publishedDate = dto.publishedDate;
        this.expiryDate = dto.expiryDate;
        this.completedDate = dto.completedDate;
        this.purchaserOneStatus = dto.purchaserOneStatus;
        this.purchaserOneToken = dto.purchaserOneToken;
        this.purchaserOneEmailSentDate = dto.purchaserOneEmailSentDate;
        this.purchaserOneSignedDate = dto.purchaserOneSignedDate;
        this.purchaserTwoStatus = dto.purchaserTwoStatus;
        this.purchaserTwoToken = dto.purchaserTwoToken;
        this.purchaserTwoEmailSentDate = dto.purchaserTwoEmailSentDate;
        this.purchaserTwoSignedDate = dto.purchaserTwoSignedDate;
        this.salesAgentStatus = dto.salesAgentStatus;
        this.salesAgentSignedDate = dto.salesAgentSignedDate;
        this.version = dto.version;
        this.isActive = dto.isActive;
        this.createdDate = dto.createdDate;
        this.createdByIdentityUserId = dto.createdByIdentityUserId;
        this.lastModifiedDate = dto.lastModifiedDate;
        this.lastModifiedByIdentityUserId = dto.lastModifiedByIdentityUserId;
    };

    public toDto = (): ReservationSignatureStatusDTO => {
        return {
            id: this.id,
            reservationId: this.reservationId,
            requestStatus: this.requestStatus,
            publishedDate: this.publishedDate,
            expiryDate: this.expiryDate,
            completedDate: this.completedDate,
            purchaserOneStatus: this.purchaserOneStatus,
            purchaserOneToken: this.purchaserOneToken,
            purchaserOneEmailSentDate: this.purchaserOneEmailSentDate,
            purchaserOneSignedDate: this.purchaserOneSignedDate,
            purchaserTwoStatus: this.purchaserTwoStatus,
            purchaserTwoToken: this.purchaserTwoToken,
            purchaserTwoEmailSentDate: this.purchaserTwoEmailSentDate,
            purchaserTwoSignedDate: this.purchaserTwoSignedDate,
            salesAgentStatus: this.salesAgentStatus,
            salesAgentSignedDate: this.salesAgentSignedDate,
            version: this.version,
            isActive: this.isActive,
            createdDate: this.createdDate,
            createdByIdentityUserId: this.createdByIdentityUserId,
            lastModifiedDate: this.lastModifiedDate,
            lastModifiedByIdentityUserId: this.lastModifiedByIdentityUserId,
        };
    };
}

export interface ReservationSignatureStatusDTO {
    id: string | undefined;
    reservationId: string;
    requestStatus: SignatureRequestStatusType;
    publishedDate: string;
    expiryDate: string;
    completedDate: string;
    purchaserOneStatus: SignatureStatusType;
    purchaserOneToken: string;
    purchaserOneEmailSentDate: string;
    purchaserOneSignedDate: string;
    purchaserTwoStatus: SignatureStatusType;
    purchaserTwoToken: string;
    purchaserTwoEmailSentDate: string;
    purchaserTwoSignedDate: string;
    salesAgentStatus: SignatureStatusType;
    salesAgentSignedDate: string;
    version: number;
    isActive: boolean;
    createdDate: string;
    createdByIdentityUserId: string;
    lastModifiedDate: string;
    lastModifiedByIdentityUserId: string;
}
